import { Place } from "../types/interfaces";

export const defaultCities: Place[] = [
  {
    name: "Tokyo",
    lat: "35.6828387",
    lon: "139.7594549",
  },
  {
    name: "Seoul",
    lat: "37.5666791",
    lon: "126.9782914",
  },
  {
    name: "San Francisco",
    lat: "37.7790262",
    lon: "-122.419906",
  },
  {
    name: "Amsterdam",
    lat: "52.3727598",
    lon: "4.8936041",
  },
  {
    name: "Manchester",
    lat: "53.4794892",
    lon: "-2.2451148",
  },
  {
    name: "New York",
    lat: "40.7127281",
    lon: "-74.0060152",
  },
  {
    name: "Montreal",
    lat: "45.4972159",
    lon: "-73.6103642",
  },
  {
    name: "Prague",
    lat: "50.0874654",
    lon: "14.4212535",
  },
  {
    name: "Tel Aviv",
    lat: "32.0852997",
    lon: "34.7818064",
  },
  {
    name: "Porto",
    lat: "41.1494512",
    lon: "-8.6107884",
  },
  {
    name: "Los Angeles",
    lat: "34.0536909",
    lon: "-118.242766",
  },
  {
    name: "London",
    lat: "51.5073219",
    lon: "-0.1276474",
  },
  {
    name: "Barcelona",
    lat: "41.3828939",
    lon: "2.1774322",
  },
  {
    name: "Sydney",
    lat: "-33.8548157",
    lon: "151.2164539",
  },
  {
    name: "Shanghai",
    lat: "31.2322758",
    lon: "121.4692071",
  },
  {
    name: "Mexico City",
    lat: "19.4326296",
    lon: "-99.1331785",
  },
  {
    name: "Sao Paulo",
    lat: "-23.5506507",
    lon: "-46.6333824",
  },
  {
    name: "Hong Kong",
    lat: "22.2793278",
    lon: "114.1628131",
  },
  {
    name: "Paris",
    lat: "48.8588897",
    lon: "2.3200410217200766",
  },
  {
    name: "Dubai",
    lat: "25.2653471",
    lon: "55.2924914",
  },
  {
    name: "Budapest",
    lat: "47.48138955",
    lon: "19.14609412691246",
  },
  {
    name: "Rome",
    lat: "41.8933203",
    lon: "12.4829321",
  },
  {
    name: "Istanbul",
    lat: "41.0096334",
    lon: "28.9651646",
  },
];